import * as React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { DateFormat } from "components/common/formatter";
import * as api from "api/index";
import DataList from "components/MatterDetails/DataList";
import { handleApiError } from "Helper";
import { Tile } from "components/UIComponents/Tile";
import { Checkbox } from "@progress/kendo-react-inputs";
import { TileWrapper } from "components/UIComponents/TileWrapper.jsx";

const MattersCompletionPage = (props) => {
  const matterDetails = useSelector((state) => state.mattersList);
  const [balances, setBalances] = useState({});

  const [currentMatterDetails, setcurrentMatterDetails] = useState();
  useEffect(() => {
    if (matterDetails !== null) {
      setcurrentMatterDetails(
        matterDetails?.matterViewDetails[props.reference]?.data
      );
    }
  });

  const dataGetter = async () => {
    try {
      const data = await api.getMattersBalances(currentMatterDetails.matterId);
      if (data?.data?.data !== undefined) {
        setBalances(data.data.data);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    if (currentMatterDetails !== undefined) {
      dataGetter();
    }
  }, [currentMatterDetails]);

  return (
    <TileWrapper>
      <div className="row g-2 d-flex">
        <div className="col-12 col-xl-6">
          <Tile
            heading="Completion"
            height={"300px"}
            className=" px-4 pt-2 pb-0 overflow-auto"
          >
            <div className="">
              <div>
                <DataList
                  text="Closed:"
                  value={
                    <Checkbox
                      readOnly={true}
                      value={currentMatterDetails?.closed}
                    />
                  }
                  width={"w-100"}
                  valueClass={"ms-4"}
                  keyStyles={{ minWidth: "150px" }}
                  //   className={'mt-1'}
                />
              </div>
              <div>
                <DataList
                  text="Closed Date:"
                  value={DateFormat(currentMatterDetails?.dateClosed)}
                  width={"w-100"}
                  valueClass={"ms-4"}
                  keyStyles={{ minWidth: "150px" }}
                  //   className={'mt-1'}
                />
              </div>
              <div>
                <DataList
                  text="Location:"
                  value={currentMatterDetails?.branch}
                  width={"w-100"}
                  valueClass={"ms-4"}
                  //   className={'mt-1'}
                  keyStyles={{ minWidth: "150px" }}
                />
              </div>
            </div>
          </Tile>
        </div>

        <div className="col-12 col-xl-6">
          <Tile
            heading="GDRP"
            height={"300px"}
            className="px-4 pt-2 pb-0 overflow-auto"
          >
            <div style={{ width: "90%" }}>
              <div className="">
                <DataList
                  statusChart={true}
                  // className="mt-3"
                  valueClass={"ms-4"}
                  text="Deleted:"
                  value={
                    <Checkbox
                      readOnly={true}
                      value={currentMatterDetails?.closed}
                    />
                  }
                  width={"w-100"}
                  keyStyles={{ minWidth: "150px" }}
                />
                <DataList
                  text="Date Deleted:"
                  value={DateFormat(currentMatterDetails?.dateDeleted)}
                  width={"w-100"}
                  valueClass={"ms-4"}
                  //   className={'mt-1'}
                  keyStyles={{ minWidth: "150px" }}
                />
              </div>
            </div>
          </Tile>
        </div>
      </div>
    </TileWrapper>
  );
};

export default MattersCompletionPage;
